var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9106 19.3177L18.6099 29.483C19.3084 30.7288 21.1478 30.5765 21.6318 29.2328L30.9236 3.43743C31.4016 2.11038 30.1178 0.826551 28.7908 1.30457L2.99531 10.5964C1.65165 11.0804 1.49933 12.9198 2.74508 13.6182L12.9106 19.3177ZM12.9106 19.3177L16.6556 15.5725L12.9106 19.3177Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9106 19.3177L18.6099 29.483C19.3084 30.7288 21.1478 30.5765 21.6318 29.2328L30.9236 3.43743C31.4016 2.11038 30.1178 0.826551 28.7908 1.30457L2.99531 10.5964C1.65165 11.0804 1.49933 12.9198 2.74508 13.6182L12.9106 19.3177ZM12.9106 19.3177L16.6556 15.5725",
    stroke: "#0F172A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms);
export default __webpack_public_path__ + "static/media/sms.303927486941caba89beb89bfc193400.svg";
export { ForwardRef as ReactComponent };